/**
 * Short locale label for UI. Ukrainian uses ISO 639-1 `uk` in URLs; uppercasing it reads as
 * "UK" (United Kingdom), so we show ISO 3166-1 "UA" instead.
 */
export function getLocaleDisplayCode(locale: string): string {
    if (locale.toLowerCase() === 'uk') return 'UA'
    return locale.toUpperCase()
}
